<template v-if="notificationLog">
  <div>
    <v-card>
      <v-container>
        <p class="mt-2"><strong>Job Name:</strong> {{ notificationLog.jobName }}</p>
        <SimpleCollapsibleSection v-for="log in notificationLog[log]" :key="log.id" :title="$filters.DateTimeFilter(log.sentDate)" highlight>
          <div class="mb-2">
            Id: <strong>{{ log.id }}</strong>
          </div>
          <div class="mb-2">
            Email Reference: <strong>{{ log.emailReference }}</strong>
          </div>
          <div class="mb-2">
            Notification Type: <strong>{{ log.notificationType }}</strong>
          </div>
          <div class="mb-2">
            Tag: <strong>{{ log.tag }}</strong>
          </div>
          <div class="mb-2">
            Skipped: <strong>{{ log.skipped }}</strong>
          </div>
          <div class="mb-2">Recipients:</div>
          <div class="ml-3">
            <SimpleCollapsibleSection
              v-show="value"
              v-for="(value, propertyName) in log.recipients"
              :key="propertyName"
              :title="propertyName"
              highlight
            >
              <template v-if="value">
                <template v-if="isArray(value) && value.length">
                  <div v-for="(el, index) in value" :key="index">
                    <div>Id: {{ el.id }}</div>
                    <div>
                      Display Name: <strong>{{ el.displayName }}</strong>
                    </div>
                    <div>
                      Mail: <strong>{{ el.mail }}</strong>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div>Id: {{ value.id }}</div>
                  <div>
                    Display Name: <strong>{{ value.displayName }}</strong>
                  </div>
                  <div>
                    Mail: <strong>{{ value.mail }}</strong>
                  </div>
                </template>
              </template>
            </SimpleCollapsibleSection>
          </div>
        </SimpleCollapsibleSection>
        <template v-if="notificationLog.logHistory">
          <h4 class="my-3">History</h4>
        </template>
        <SimpleCollapsibleSection
          v-for="log in notificationLog.logHistory || []"
          :key="log.id"
          :title="$filters.DateTimeFilter(log.sentDate)"
          highlight
        >
          <div class="mb-2">
            Id: <strong>{{ log.id }}</strong>
          </div>
          <div class="mb-2">
            Email Reference: <strong>{{ log.emailReference }}</strong>
          </div>
          <div class="mb-2">
            Notification Type: <strong>{{ log.notificationType }}</strong>
          </div>
          <div class="mb-2">
            Tag: <strong>{{ log.tag }}</strong>
          </div>
          <div class="mb-2">
            Skipped: <strong>{{ log.skipped }}</strong>
          </div>
          <div class="mb-2">Recipients:</div>
          <div class="ml-3">
            <SimpleCollapsibleSection
              v-show="value"
              v-for="(value, propertyName) in log.recipients"
              :key="propertyName"
              :title="propertyName"
              highlight
            >
              <template v-if="value">
                <template v-if="isArray(value) && value.length">
                  <div v-for="(el, index) in value" :key="index">
                    <div>Id: {{ el.id }}</div>
                    <div>
                      Display Name: <strong>{{ el.displayName }}</strong>
                    </div>
                    <div>
                      Mail: <strong>{{ el.mail }}</strong>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div>Id: {{ value.id }}</div>
                  <div>
                    Display Name: <strong>{{ value.displayName }}</strong>
                  </div>
                  <div>
                    Mail: <strong>{{ value.mail }}</strong>
                  </div>
                </template>
              </template>
            </SimpleCollapsibleSection>
          </div>
        </SimpleCollapsibleSection>
      </v-container>
    </v-card>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import SimpleCollapsibleSection from '@/components/SimpleCollapsibleSection'
import NotificationTesterLogView from '@/components/developer/NotificationTesterLogView'

export default {
  name: 'NotificationTesterLogView',
  components: {
    SimpleCollapsibleSection,
    NotificationTesterLogView
  },
  props: {
    notificationLog: {
      type: Object,
      default: undefined
    },
    log: {
      type: String,
      default: 'log'
    }
  },
  methods: {
    isArray(value) {
      return Array.isArray(value)
    }
  }
}
</script>

<style></style>
